import { CSSObject, Theme } from '@emotion/react'
import styled from '@emotion/styled'
import * as CSS from 'csstype'
import { FusionColor } from '../../../theme/FusionStyle'

export const L2ErfRow = styled.div(({theme}): CSSObject => ({
	gridColumn: 'rowstartln / rowendln',
	display: 'grid',
	gridTemplateColumns: 'subgrid',
	breakInside: 'avoid',
	position: 'relative',
}))

interface L2ErfRowContentProps {
	alignItems?: CSS.Property.AlignItems,
	justifyContent?: CSS.Property.JustifyContent,
	bottom?: boolean,
}

export const L2ErfRowControls = styled.div<L2ErfRowContentProps>(({theme, alignItems = 'center', bottom = false}) => ({
	gridColumn: 'rowstartln / controlendln',
	display: 'grid',
	gridTemplateColumns: 'subgrid',
	alignItems,  // or, "flex-start"
	justifyItems: 'center',
	backgroundColor: `${theme.colors.second} !important`,
	padding: theme.spacing(1, 2),
	borderBottomLeftRadius: bottom ? theme.borderRadius : 'initial',
}))

export const L2ErfRowContent = styled.div<L2ErfRowContentProps>(({theme, justifyContent = 'flex-start', alignItems = 'flex-start'}): CSSObject => ({
	padding: theme.spacing(1, 2.5, 1, 0.5),
	display: 'flex',
	flexDirection: 'column',
	justifyContent,
	alignItems,
	wordWrap: 'break-word',
	overflowWrap: 'break-word',
	whiteSpace: 'normal',
	gap: theme.spacing(1),
}))

export const L2ErfSpacerRow = () => (
	<L2ErfRow>
		<L2ErfRowControls />
		<L2ErfRowContent />
	</L2ErfRow>
)

const L2ErfYPadRowRoot = styled(L2ErfRow)(({
	'& *': {
		padding: '2px 0',
	},
}))

export const L2ErfYPadRow = ({bottom = false}) => (
	<L2ErfYPadRowRoot>
		<L2ErfRowControls bottom={bottom} />
		<L2ErfRowContent />
	</L2ErfYPadRowRoot>
)
